import { SearchTree } from '../../../types/searchTree';
import { ApiAbstract } from '../abstract';

export class ApiSearchTree extends ApiAbstract<any, SearchTree> {}
